import createReducer from "./reducerUtils";
import {
  LOAD_CUENTA,
  LOAD_CUENTAS,
  LOADING_CUENTAS,
  LOADING_CUENTA,
  LOAD_MOVIMIENTOS,
  LOADING_MOVIMIENTOS,
  LOADING_APERTURAR_CUENTA_AHORROS_VALIDAR,
  LOADING_APERTURAR_CUENTA_AHORROS_CONFIRMAR,
  LOADING_APERTURAR_CUENTA_DPF_VALIDAR,
  LOADING_APERTURAR_CUENTA_DPF_CONFIRMAR,
  LOAD_CUENTAS_OPERACIONES,
  LOADING_CUENTAS_OPERACIONES,
  LOAD_CUENTAS_DEPOSITO,
  LOADING_CUENTAS_DEPOSITO,
  LOADING_CUENTAS_OPERACIONES_PRYMERA,
  LOAD_CUENTAS_OPERACIONES_PRYMERA,
  LOAD_PRODUCTOS_CUENTA_APERTURA,
  LOADING_PRODUCTOS_CUENTA_APERTURA,
} from "../actions/actionTypes";

const initialState = {
  cuentas: [],
  cuenta: null,
  cuentasOperaciones: [],
  cuentasOperacionesPrymera: [],
  cuentasDeposito: [],
  movimientos: [],
  loadingCuentas: false,
  loadingCuenta: false,
  loadingCuentasOperaciones: false,
  loadingCuentasOperacionesPrymera: false,
  loadingCuentasDeposito: false,
  loadingMovimientos: false,
  loadingAperturarCuentaAhorroValidar: false,
  loadingAperturarCuentaAhorroConfirmar: false,
  loadingAperturarCuentaDPFValidar: false,
  loadingAperturarCuentaDPFConfirmar: false,
  productosCuenta: [],
  loadingProductosCuentaApertura: false,
};

const loadCuentas = (state, payload) => {
  return {
    ...state,
    cuentas: payload.cuentas,
  };
};

const loadCuentasOperaciones = (state, payload) => {
  return {
    ...state,
    cuentasOperaciones: payload.cuentasOperaciones,
  };
};

const loadCuentasOperacionesPrymera = (state, payload) => {
  return {
    ...state,
    cuentasOperacionesPrymera: payload.cuentasOperacionesPrymera,
  };
};

const loadCuentasDeposito = (state, payload) => {
  return {
    ...state,
    cuentasDeposito: payload.cuentasDeposito,
  };
};

const loadCuenta = (state, payload) => {
  return {
    ...state,
    cuenta: payload.cuenta,
  };
};

const loadMovimientos = (state, payload) => {
  return {
    ...state,
    movimientos: payload.movimientos,
  };
};

const loadProductosCuentaApertura = (state, payload) => {
  return {
    ...state,
    productosCuenta: payload.productosCuenta,
  };
};

const loadingCuentas = (state, payload) => {
  return { ...state, loadingCuentas: payload.loading };
};

const loadingCuenta = (state, payload) => {
  return { ...state, loadingCuenta: payload.loading };
};

const loadingMovimientos = (state, payload) => {
  return { ...state, loadingMovimientos: payload.loading };
};

const loadingAperturarCuentaAhorroValidar = (state, payload) => {
  return { ...state, loadingAperturarCuentaAhorroValidar: payload.loading };
};

const loadingAperturarCuentaAhorroConfirmar = (state, payload) => {
  return { ...state, loadingAperturarCuentaAhorroConfirmar: payload.loading };
};

const loadingAperturarCuentaDPFValidar = (state, payload) => {
  return { ...state, loadingAperturarCuentaDPFValidar: payload.loading };
};

const loadingAperturarCuentaDPFConfirmar = (state, payload) => {
  return { ...state, loadingAperturarCuentaDPFConfirmar: payload.loading };
};

const loadingCuentasOperaciones = (state, payload) => {
  return { ...state, loadingCuentasOperaciones: payload.loading };
};

const loadingCuentasOperacionesPrymera = (state, payload) => {
  return { ...state, loadingCuentasOperacionesPrymera: payload.loading };
};

const loadingCuentasDeposito = (state, payload) => {
  return { ...state, loadingCuentasDeposito: payload.loading };
};

const loadingProductosCuentaApertura = (state, payload) => {
  return { ...state, loadingProductosCuentaApertura: payload.loading };
};

export default createReducer(initialState, {
  [LOAD_CUENTAS]: loadCuentas,
  [LOADING_CUENTAS]: loadingCuentas,
  [LOAD_CUENTAS_OPERACIONES]: loadCuentasOperaciones,
  [LOADING_CUENTAS_OPERACIONES]: loadingCuentasOperaciones,
  [LOAD_CUENTAS_OPERACIONES_PRYMERA]: loadCuentasOperacionesPrymera,
  [LOADING_CUENTAS_OPERACIONES_PRYMERA]: loadingCuentasOperacionesPrymera,
  [LOAD_CUENTAS_DEPOSITO]: loadCuentasDeposito,
  [LOADING_CUENTAS_DEPOSITO]: loadingCuentasDeposito,
  [LOAD_CUENTA]: loadCuenta,
  [LOADING_CUENTA]: loadingCuenta,
  [LOAD_MOVIMIENTOS]: loadMovimientos,
  [LOADING_MOVIMIENTOS]: loadingMovimientos,
  [LOADING_APERTURAR_CUENTA_AHORROS_VALIDAR]: loadingAperturarCuentaAhorroValidar,
  [LOADING_APERTURAR_CUENTA_AHORROS_CONFIRMAR]: loadingAperturarCuentaAhorroConfirmar,
  [LOADING_APERTURAR_CUENTA_DPF_VALIDAR]: loadingAperturarCuentaDPFValidar,
  [LOADING_APERTURAR_CUENTA_DPF_CONFIRMAR]: loadingAperturarCuentaDPFConfirmar,
  [LOAD_PRODUCTOS_CUENTA_APERTURA]: loadProductosCuentaApertura,
  [LOADING_PRODUCTOS_CUENTA_APERTURA]: loadingProductosCuentaApertura,
});
